import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cn from 'classnames';
import { Button } from 'antd';

import { PLAN_DATE_FORMAT } from '../../constants';

import s from './styles.less';

const propTypes = {
  onCancel: PropTypes.func.isRequired,
  cancelled: PropTypes.bool,
  cancelledAt: PropTypes.string,
};
const defaultProps = {
  cancelled: false,
};

const CancelAction = ({ onCancel, cancelled, cancelledAt }) => (
  <Fragment>
    {!cancelled && (
      <Button type="danger" htmlType="button" onClick={onCancel} ghost>
        Cancel plan
      </Button>
    )}
    {cancelled && (
      <Fragment>
        <div className={s.cancelledActionTitle}>Cancelled</div>
        <div className={cn(s.meta, s.italic)}>
          {cancelledAt && (
            <span>{moment(cancelledAt).format(PLAN_DATE_FORMAT)}</span>
          )}
          {!cancelledAt && <span>date was not specified</span>}
        </div>
      </Fragment>
    )}
  </Fragment>
);

CancelAction.propTypes = propTypes;
CancelAction.defaultProps = defaultProps;

export default CancelAction;
